import React from "react";

// utils
import { getRandomBgColor } from "shared/utils";

// styles
import styles from './Thumbnail.module.scss';

const APP_PROFILE_URL = process.env.REACT_APP_PROFILE_URL;

const Thumbnail = ({
        backgroundColor=false,
        initials,
        image=false,
        size='small' /*tiny, small, large */
    }) => {
    const randomColor = getRandomBgColor();
    const thumbnailStyles = `${ styles.thumbnail } ${ styles[size] }`;

    if(image){
        return (
            <div className={ thumbnailStyles }>
                <img src={ APP_PROFILE_URL + image } alt=" " />
            </div>
        )
    }

    return (
        <div
            style={{
                'backgroundColor': backgroundColor ? backgroundColor : randomColor,
            }}
            className={ thumbnailStyles }>
            { initials }
        </div>
    )
}

export default React.memo(Thumbnail);
